import type { Image } from '@frontend/libs/types/media'

import Fancybox from '@frontend/components/fancybox/Fancybox'
import { isMobileDevice } from '@frontend/libs/utils'

import type { DeviceSpecificValue, GalleryType } from './lib/type'

import GalleryCarousel from './GalleryCarousel'
import GalleryGrid from './GalleryGrid'
import GalleryImage from './GalleryImage'

export type GalleryProps = {
  columns: DeviceSpecificValue
  enableLightbox: boolean
  firstImageFullWidth?: boolean
  galleryType: GalleryType
  gaps: DeviceSpecificValue
  images: Image[]
  mobileCarousel: boolean
  showNavigation?: boolean
  showPagination?: boolean
}

function Gallery({
  columns,
  enableLightbox,
  firstImageFullWidth = false,
  galleryType,
  gaps,
  images,
  mobileCarousel,
  showNavigation,
  showPagination,
}: Readonly<GalleryProps>) {
  const renderGalleryGrid = (isLightboxEnabled: boolean) => (
    <GalleryGrid
      $columns={columns}
      $firstImageFullWidth={firstImageFullWidth}
      $gaps={gaps}
    >
      {images.map((image) => (
        <GalleryImage
          image={image}
          isLightboxEnabled={isLightboxEnabled}
          key={image.name}
        />
      ))}
    </GalleryGrid>
  )

  if (galleryType === 'grid') {
    if (isMobileDevice && mobileCarousel) {
      return (
        <GalleryCarousel
          columns={columns}
          enableLightbox={enableLightbox}
          gaps={gaps}
          images={images}
          showNavigation={showNavigation}
          showPagination={showPagination}
        />
      )
    }

    if (enableLightbox) {
      return (
        <Fancybox
          options={{
            Carousel: {
              infinite: false,
            },
          }}
        >
          {renderGalleryGrid(true)}
        </Fancybox>
      )
    }

    return renderGalleryGrid(false)
  }

  return (
    <GalleryCarousel
      columns={columns}
      enableLightbox={enableLightbox}
      gaps={gaps}
      images={images}
      showNavigation={showNavigation}
      showPagination={showPagination}
    />
  )
}

export default Gallery
